import { Component, AfterViewInit, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, } from '@angular/router';
import {
  TdLoadingService,
  TdMediaService,
  TdDialogService,
} from '@covalent/core';
import { MdSelect } from '@angular/material';

/*import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';*/

import { PatronesService, LoginService, } from '../../../../../services/';
import { Patron } from '../../../../../models';
import { AltaTestComponent } from './altatest/altatest.component';

@Component({
  selector: 'qs-testdisponibles',
  styleUrls: ['./testdisponibles.component.scss'],
  templateUrl: './testdisponibles.component.html',
  viewProviders: [ PatronesService ],
})

export class TestDisponiblesComponent implements AfterViewInit {

  private auxiliarPatrones: any = [];
  public mode: string;
  public nodes: any = [];
  public title: string;
  public idPaciente: string;
  public edadPaciente: string;
  public sexoPaciente: string;
  public tipoEdad: string;
  public idPatron: string;
  public sub: any;

  public patron: Patron;
  public patrones: Patron[];
  public searchTerm: string = '';

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void { // OK
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.sexoPaciente = this._loginService.consulta.sexo;
    let age: any = this._loginService.consulta.edad;
    let splitted: any = age.split(' ', 2);
    this.edadPaciente = splitted[0];
    let tEdad: any = splitted[1];
    this.tipoEdad = tEdad.charAt(0);

    this._loadingService.register('testdisponibles.load');
    // this._patronesService.obtenerListadoValoraciones(this.idPaciente, 5).subscribe((res: any) => {
    this._patronesService.obtenerListadoValoraciones(5).subscribe((res: any) => {

      // let aaaa: any;
     // this.patrones = res.respuesta;

      for (let respuesta in res.respuesta) {
      if (res.respuesta[respuesta].sexo === this.sexoPaciente || res.respuesta[respuesta].sexo === '') {
        if (res.respuesta[respuesta].tipoEdad === this.tipoEdad || res.respuesta[respuesta].tipoEdad === '') {
          if ((Number(res.respuesta[respuesta].edadDesde) < Number(this.edadPaciente) &&
              Number(res.respuesta[respuesta].edadHasta) > Number(this.edadPaciente)) || (
              Number(res.respuesta[respuesta].edadDesde) === 0 && Number(res.respuesta[respuesta].edadHasta) === 0)) {

            this.auxiliarPatrones.push({
              id: res.respuesta[respuesta].idPatron,
              name: res.respuesta[respuesta].textoPatron,
              idPadre: res.respuesta[respuesta].idPadre,
            });
          }
        } else if (res.respuesta[respuesta].tipoEdad === undefined) {
          this.auxiliarPatrones.push({
            id: res.respuesta[respuesta].idPatron,
            name: res.respuesta[respuesta].textoPatron,
            idPadre: res.respuesta[respuesta].idPadre,
          });
        }
      }
    }
      for ( let i: any = 0; i < this.auxiliarPatrones.length; i++) {
        if (this.auxiliarPatrones[i].idPadre === undefined) {
          let hijos: any = [];
          for (let x: any = 0; x < this.auxiliarPatrones.length; x++) {
            if (this.auxiliarPatrones[x].idPadre === this.auxiliarPatrones[i].id) {
              hijos.push({
                id: this.auxiliarPatrones[x].id,
                name: this.auxiliarPatrones[x].name,
              });
            }
          }
          this.nodes.push({
            id: this.auxiliarPatrones[i].id,
            name: this.auxiliarPatrones[i].name,
            children: hijos,
          });
        }
    }

    /* for (let respuesta in res.respuesta) {
      if(res.respuesta[respuesta].sexo === this.sexoPaciente || res.respuesta[respuesta].sexo == undefined){
        if(res.respuesta[respuesta].tipoEdad === this.tipoEdad || res.respuesta[respuesta].tipoEdad == undefined){
          if((Number(res.respuesta[respuesta].edadDesde) < Number(this.edadPaciente) &&
          Number(res.respuesta[respuesta].edadHasta) > Number(this.edadPaciente)) || (
            Number(res.respuesta[respuesta].edadDesde) == 0 && Number(res.respuesta[respuesta].edadHasta) == 0)){
            this.nodes.push({
              id: res.respuesta[respuesta].idPatron,
              name: res.respuesta[respuesta].textoPatron,
            });
          }
        }
      }
      else if(res.respuesta[respuesta].tipoEdad == undefined){
        this.nodes.push({
          id: res.respuesta[respuesta].idPatron,
          name: res.respuesta[respuesta].textoPatron,
        });
      }

    } */
      // this.nodes = this.patrones;
      this._loadingService.resolve('testdisponibles.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo test.', 'OK', 6000);
      this._loadingService.resolve('testdisponibles.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  clearSearchInput(input: any, tree: any): void {
    input.value = '';
    tree.collapseAll();
    tree.clearFilter();
    this._changeDetectorRef.detectChanges();
  }

  search(tree: any, key: any): void {
    if (key.length > 2) {
      tree.filterNodes(key, true);
    }
    this._changeDetectorRef.detectChanges();
  }

  selectNode($event: any): void {
    if ($event.node.data.idPadre !== 'System.DBNull') {
      // Abrimos vista detalle de alta
      this.openDetail($event.node.data);
    } else {
      // Expandimos el la rama
      if ($event.node.hasChildren) {
        if ($event.node.isExpanded) {
          $event.node.collapse();
        } else {
          $event.node.toggleExpanded();
        }
        $event.node.toggleActivated();
      }
    }
  }

  /**
   * Abre una vista detalle de la consulta
   * @param tecnica
   */
  openDetail(patron: any): void {
    let dialogRef: any = this._dialogService.open( AltaTestComponent, {
      data: patron,
      width: '92%',
      role: 'dialog',
      height: '90%',
    });
    dialogRef.componentInstance.patron = patron;
    dialogRef.componentInstance.titulo = patron.name;
    dialogRef.componentInstance.idPatron = patron.id;
  }

  close(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/modanamnesis',
    { outlets: { modanamnesis: ['test'] } }]);
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/test/testdisponibles/testdisponibles.component.ts